import config from '@/cms.config'

export default ({ route }, inject) => {
  const cms = route.query.cms && JSON.parse(route.query.cms)
  const editable = route.query.editable && JSON.parse(route.query.editable)
  const showChanges = route.query.show_changes && JSON.parse(route.query.show_changes)
  const branchID = Number(process.env.BRANCH_ID || 1)

  inject('branchID', branchID)

  if (cms) {
    inject('cms', {
      config,
      editable,
      showChanges
    })
  } else {
    inject('cms', false)
  }
}
